<template>
  <div class="not-found-content">
    <p class="display-1 font-weight-light mt-12">Sorry the page is not found.</p>
    <v-icon>mdi-emoticon-sad-outline</v-icon>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>